import { useEffect, useState } from "react";

import { formatUsDate, parseUsDate } from "./ganttUtils";

export const GanttActionButton = ({ icon, label, onClick, disabled, variant }) => (
  <button className={`gantt-icon-action ${variant || ""}`} aria-label={label} title={label} onClick={onClick} disabled={disabled}>
    <GanttIcon name={icon} />
    <span className="gantt-action-label">{label}</span>
  </button>
);

export const DateInput = ({ value, disabled, onChange }) => {
  const [text, setText] = useState(formatUsDate(value));

  useEffect(() => {
    setText(formatUsDate(value));
  }, [value]);

  const commit = () => {
    const parsed = parseUsDate(text);
    if (parsed) onChange(parsed);
    else setText(formatUsDate(value));
  };

  return (
    <input
      aria-label="Date in MM/DD/YYYY format"
      value={text}
      disabled={disabled}
      placeholder="MM/DD/YYYY"
      onChange={(event) => setText(event.target.value)}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === "Enter") event.currentTarget.blur();
      }}
    />
  );
};

export const GanttIcon = ({ name }) => {
  const icons = {
    spark: <path d="M12 2l1.3 5.1L18 9l-4.7 1.9L12 16l-1.3-5.1L6 9l4.7-1.9L12 2zm6 11l.8 2.7L21 17l-2.2 1.3L18 21l-.8-2.7L15 17l2.2-1.3L18 13zM5 12l.7 2.3L8 15l-2.3.7L5 18l-.7-2.3L2 15l2.3-.7L5 12z" />,
    excel: <path d="M5 3h10l4 4v14H5V3zm9 1.5V8h3.5M8 11l2.2 3L8 17h2l1.2-1.8L12.5 17h2L12.3 14l2.2-3h-2l-1.2 1.8L10 11H8z" />,
    save: <path d="M5 4h12l2 2v14H5V4zm3 0v6h8V4m-8 12h8v4H8v-4z" />,
    expand: <path d="M4 9V4h5M4 4l6 6m10-1V4h-5m5 0l-6 6M4 15v5h5m-5 0l6-6m10 1v5h-5m5 0l-6-6" />,
    collapse: <path d="M10 4v6H4m0 0l6-6m4 0v6h6m0 0l-6-6M10 20v-6H4m0 0l6 6m4 0v-6h6m0 0l-6 6" />,
    arrowRight: <path d="M5 12h14m-6-6l6 6-6 6" />,
    arrowLeft: <path d="M19 12H5m6-6l-6 6 6 6" />
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">{icons[name]}</svg>;
};
